/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

import '../stylesheets/tailwind.css';
import { mountToaster } from '../application/mountToaster';

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountToaster);
} else {
  mountToaster();
}

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

// Support component names relative to this directory:

Date.prototype.formatDate = function() {
  var mm = this.getMonth() + 1; // getMonth() is zero-based
  var dd = this.getDate();

  return [this.getFullYear(),
          (mm>9 ? '' : '0') + mm,
          (dd>9 ? '' : '0') + dd
         ].join('-');
};

var componentRequireContext = require.context("application", true, /^((?!__tests__|\.test\.|\.spec\.).)*\.(jsx?|tsx?)$/);
var ReactRailsUJS = require("react_ujs");

var customGetConstructor = function(className) {
  var parts = className.split(".");
  var filename = parts.shift();
  var keys = parts;
  var component = null;
  var availableKeys = componentRequireContext.keys();
  var paths = [
    filename + '.tsx',
    filename + '.jsx',
    filename + '.ts',
    filename + '.js',
    filename + '/index.tsx',
    filename + '/index.jsx',
    filename + '/index.ts',
    filename + '/index.js',
    filename
  ];
  
  for (var i = 0; i < paths.length; i++) {
    var fullPath = "./" + paths[i];
    if (availableKeys.indexOf(fullPath) !== -1) {
      try {
        component = componentRequireContext(fullPath);
        break;
      } catch (e) {}
    }
  }
  
  if (!component) {
    return null;
  }
  
  keys.forEach(function(k) {
    if (component) {
      component = component[k];
    }
  });
  
  if (component && component.__esModule) {
    component = component["default"];
  }
  
  return component;
};

ReactRailsUJS.getConstructor = customGetConstructor;

